// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WX-z","hovered":"XX-z","hoverImage":"YX-z","mainImage":"ZX-z","imageNoBackground":"_X-z","fullSizeImage":"aY-z"};